export enum PageStylesEnum {
    BASIC = 'background-basic',
    YELLOW = 'background-yellow',
    GRAY = 'background-gray',
    CREAM = 'background-cream',
}
